import {connect} from 'react-redux'
import Radio from '../components/Radio.jsx'
import {
  setPlayback
} from '../../../actions/Actions.js'

function mapStateToProps (state) {
  return {
    autoplay: state.radio.autoplay
  }
}

function mapDispatchToProps (dispatch) {
  return {
    setPlayback: (bol) => dispatch(setPlayback(bol))
  }
}

const RadioContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Radio)

export default RadioContainer
